export const GLOBAL_CTAS_PROMO_BANNER_FLAG_NAME = 'pen-5021_v1'
